<template>
  <p class="px-10 text-center text-gray-400">
    <slot></slot>
  </p>
</template>
